import { reverb_search_Filter } from '@reverbdotcom/commons/src/gql/graphql';
import { renameParams } from '@reverbdotcom/commons/src/facet_utils';
import { isBrandPage, isShopPage, isSimilarItemPage, isFavoritesPage } from '@reverbdotcom/commons/src/url_helpers';
import { Location } from 'history';
import { renameRqlParam } from './shared/rql_param_helper';

// Given an array of all listing filters from a graphql query,
// returns only relevant filters (and filter options) to display,
// and URL (brand page, shop page, marketplace, CSP).
export function listingsFilters(
  filters: reverb_search_Filter[],
  location: Location,
  greatValueFilterEnabled = false,
): reverb_search_Filter[] {
  // Removes the 'combined_shipping' option from the
  // `Show Only` || `Find a Deal` filter if not viewing a shop page
  if (!isShopPage(location)) {
    filters = filters.map((filter) => {
      if (filter.key !== 'SHOW_ONLY' && filter.key !== 'FIND_A_DEAL') {
        return filter;
      }

      return {
        ...filter,
        options: filter.options.filter((o) => o.paramName !== 'combined_shipping'),
      };
    });
  }

  // Removes the sidebar keyword search when viewing a brand or similar item page
  if (isBrandPage(location) || isSimilarItemPage(location)) {
    filters = filters.filter(filter => filter.key !== 'TEXT_QUERY');
  }

  if (isFavoritesPage(location)) {
    filters = filters.map((filter) => {
      if (filter.widgetType !== 'SORT') {
        return filter;
      }

      return {
        ...filter,
        options: filter.options.filter(f => f.optionValue !== 'published_at|desc'),
      };
    });
  }

  if (!greatValueFilterEnabled) {
    filters = filters.map((filter) => {
      if (filter.key !== 'FIND_A_DEAL') {
        return filter;
      }

      return {
        ...filter,
        options: filter.options.filter((o) => o.paramName !== 'great_value'),
      };
    });
  }

  return renameParams(filters, renameRqlParam);
}
export function selectedFilters(
  filters: reverb_search_Filter[],
): string {
  const filterValues = [];
  filters.map((filter) => {
    filter.options.filter((o) => {
      if (o.selected) {
        filterValues.push(o.paramName + ':' + o.name);

      }
      if (o.subFilter != null) {
        o.subFilter.options.forEach(s => {
          if (s.selected) {
            filterValues.push(s.paramName + ':' + s.name);
          }
        });
      }
    });
  });
  if (filterValues.length > 0) {
    return filterValues.join('|');
  } else {
    return '';
  }
}
